import {useState} from "react";
import InfoIcon from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CustomDialog from "../../../../../../components/Dialog/DiaCompMedium";
//import AgeTextInfo from "./AgeTextInfo";


export default function DiaHeartData() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
    <Tooltip title="Info" placement="left">
        <IconButton onClick={handleOpen} size="small">
              <InfoIcon sx={{ '&:hover': { transform: 'scale(1.1)', color: 'quartiary.main', } }}/>
        </IconButton>   
    </Tooltip>

<CustomDialog open={open} onClose={handleClose}

    title="What is the biological age?"
    content = {""}
/>

</>
)}